import { Box, MenuItem, TextField } from "@mui/material";

import { PriorityRequestFormFilter, PriorityRequestReachabilityFilter } from "@/api";
import { CounselorSelect } from "@/common/components/counselor-select/CounselorSelect";
import { PriorityRequestFilters } from "@/pages/priority-requests/PriorityRequests.types";
import { FORM_FILTER_OPTIONS, REACHABILITY_FILTER_OPTIONS } from "@/pages/priority-requests/PriorityRequests.utils";
import { useTranslation } from "@/translations";

const FILTER_FIELD_MIN_WIDTH = 230;

interface Props {
  filters: PriorityRequestFilters;
  onChange: (changes: Partial<PriorityRequestFilters>) => void;
}

export function PriorityRequestsFilterBar({ filters, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexWrap="wrap" gap={2}>
      <CounselorSelect
        selectedCounselor={filters.counselorId}
        onSelectCounselor={(counselorId) => onChange({ counselorId })}
        allOptionLabel={t("priorityRequests.filter.allCounselors")}
        label={t("priorityRequests.filter.counselor")}
        minWidth={FILTER_FIELD_MIN_WIDTH}
      />

      <TextField
        select
        label={t("priorityRequests.filter.reachability")}
        value={filters.reachability}
        onChange={(e) => onChange({ reachability: e.target.value as PriorityRequestReachabilityFilter })}
        sx={{ minWidth: FILTER_FIELD_MIN_WIDTH }}
      >
        {REACHABILITY_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {t(`priorityRequests.filter.reachabilityOptions.${option}`)}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label={t("priorityRequests.filter.form")}
        value={filters.form}
        onChange={(e) => onChange({ form: e.target.value as PriorityRequestFormFilter })}
        sx={{ minWidth: FILTER_FIELD_MIN_WIDTH }}
      >
        {FORM_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {t(`priorityRequests.filter.formOptions.${option}`)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
